import { Datagrid, EditButton, List, TextField } from "react-admin";

export const GroupList: React.FC = (props: any) => {
  return (
    <List {...props}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <TextField source="name" label="部门名称" />
        <EditButton />
      </Datagrid>
    </List>
  );
};
